// extracted by css-extract-rspack-plugin
export default {"cls1":"AnalyticsV2NavBar-cls1_IQf","cls2":"AnalyticsV2NavBar-cls2_fOA AnalyticsV2NavBar-cls1_IQf"};